'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { reportError } from '@/app/utils/functions'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { CheckIcon } from '@heroicons/react/20/solid'
import { useError } from '@/app/store'
import Button from '@/app/components/Button'
import Debug from '@/app/components/Debug'
import classNames from 'classnames'
import * as Sentry from "@sentry/nextjs"

export default function Error({ error, id }: { error?: any, id?: string }) {

    const router = useRouter()
    const sentryEventId = useError().sentryEventId
    const eventId = id || sentryEventId || Sentry.lastEventId() || null
    const [ copy, setCopy ] = useState(false)

    useEffect(() => {
        if (error) {
            reportError(error)
        }
    }, [error])

    return (
        <div className="page-content bg-black-900 fixed top-0 z-[100]">
            <main className="h-full flex-center flex-col text-center">
                <div className="text-[2rem] text-main font-bold font-gotham">
                    OOPS!
                </div>
                <div className="text-[1rem] text-main font-bold mb-8">
                    發生了一些錯誤 <br/>
                    請稍後再嘗試一次
                </div>
                { eventId &&
                    <div
                        className="px-5 relative flex-center cursor-pointer mb-20"
                        onClick={() => {
                            navigator.clipboard.writeText(eventId)
                            .then((e) => {
                                setCopy(true)
                            })
                        }}
                    >
                        <div className="text-[0.75rem] text-white">
                            {eventId.slice(0, 10)}
                        </div>
                        <div className="absolute right-0">
                            <DocumentDuplicateIcon
                                className={classNames('w-4 stroke-white hidden', {
                                    '!block': !copy
                                })}
                            />
                            <CheckIcon
                                className={classNames('w-4 fill-white hidden', {
                                    '!block': copy
                                })}
                            />
                        </div>
                    </div>
                }
                <Button
                    className="btn-main"
                    onClick={() => {
                        router.push('/')
                        if (eventId) {
                            useError.setState({ sentryEventId: null })
                        }
                    }}
                    sound="return"
                >返回首頁</Button>
            </main>
            <Debug />
        </div>
    )
}